<template>
	<article class="expertise">
		<h1>Technologies We Use</h1>
		<div class="content">
			<p>
				Only having one tool to work with limits what you can achieve.<br/>
				That's why we believe a web-developer should have a whole toolbox of knowledge.
			</p>
			<view-portfolio :data="technologies" :itemsPerPage="itemsPerPage"></view-portfolio>
		</div>
	</article>
</template>

<script>
	import viewPortfolio from '../views/viewPortfolio'
	export default {
		name: 'technologies',
		components: {
			viewPortfolio
		},
		data () {
			return {
				currentPage: 0,
				itemsPerPage: 8,
				technologies: [
					{ name: 'vuejs', image: 'static/images/tech/vuejs.jpg', caption: 'Vue.js', desc: 'JS Framework' },
					{ name: 'Webpack', image: 'static/images/tech/webpack.jpg', caption: 'Webpack', desc: 'Module bundler' },
					{ name: 'angular2', image: 'static/images/tech/angular2.jpg', caption: 'Angular 2.0', desc: 'JS Framework' },
					{ name: 'redux', image: 'static/images/tech/redux.jpg', caption: 'Redux', desc: 'State management' },
					{ name: 'git', image: 'static/images/tech/git.jpg', caption: 'Git', desc: ' Version Control' },
					{ name: 'jasmine', image: 'static/images/tech/jasmine.jpg', caption: 'Jasmine', desc: 'JS Testing Framework' },
					{ name: 'restdbio', image: 'static/images/tech/restdbio.jpg', caption: 'restdb.io', desc: 'mongoDB REST API' },
					{ name: 'nodejs', image: 'static/images/tech/nodejs.jpg', caption: 'Node.js', desc: 'Server-Side JS' },
					{ name: 'html5', image: 'static/images/tech/html5.jpg', caption: 'HTML5', desc: 'Latest standard' },
					{ name: 'Webcomponents', image: 'static/images/tech/webcomp.jpg', caption: 'Web Components', desc: 'Reusable web parts' },
					{ name: 'babel', image: 'static/images/tech/babel.jpg', caption: 'Babel', desc: 'ES6/7 Compiler' },
					{ name: 'react', image: 'static/images/tech/react.jpg', caption: 'React', desc: 'JS Framework' },
					{ name: 'polymer', image: 'static/images/tech/polymer.jpg', caption: 'Polymer', desc: 'JS Framework' },
					{ name: 'npm', image: 'static/images/tech/npm.jpg', caption: 'NPM', desc: 'Package Manager' },
					{ name: 'bower', image: 'static/images/tech/bower.jpg', caption: 'Bower', desc: 'Package Manager' },
					{ name: 'grunt', image: 'static/images/tech/grunt.jpg', caption: 'Grunt', desc: 'JS Task Runner' },
					{ name: 'gulp', image: 'static/images/tech/gulp.jpg', caption: 'Gulp', desc: 'JS Task Runner' }
				]
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// technologies.vue?07c5ac51